const AddNotificationFormDataConfig = [
  {
    key: 'notificationName',
    label: 'Notification Name',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: true,
    placeholder: 'Enter Name',
    rules: {
      required: {
        value: true,
        message: 'Notification Name is Required'
      },
      minLength: {
        value: 3,
        message: 'Notification Name must be atleast 5 characters'
      }
    }
  },
  {
    key: 'timeSpan',
    label: 'Time Period(min)',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: false,
    placeholder: 'Enter time span',
    rules: {
      required: {
        value: false,
        message: 'Time Span is Required'
      }
    }
  },
  {
    key: 'thresholdType',
    label: 'Threshold Type',
    defaultValue: '',
    type: 'dropdown',
    size: 6,
    values: [
      { label: 'Value', value: 'VALUE' },
      { label: 'Percentage', value: 'PERCENTAGE' }
    ],
    rules: {
      required: {
        value: true,
        message: 'Please select a Threshold Type'
      }
    },
    labelStyleType: 'InputLabel'
  },
  {
    key: 'thresholdValue',
    label: 'Threshold Percentage',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: false,
    placeholder: 'Enter Threshold',
    rules: {
      required: {
        value: false,
        message: 'Threshold is Required'
      }
    }
  },
  {
    key: 'thresholdLimit',
    label: 'Threshold Limit',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: false,
    placeholder: 'Enter Threshold Limit',
    rules: {
      required: {
        value: true,
        message: 'Threshold Limit is Required'
      }
    }
  },
  {
    key: 'webhookUrl',
    label: 'Webhook URL',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: false,
    placeholder: 'Enter Webhook URL'
  },
  {
    key: 'thresholdMet',
    label: 'Notify When',
    defaultValue: 'no',
    type: 'radio',
    size: 12,
    values: [
      { label: 'Threshold Met', value: 'yes' },
      { label: 'Threshold Not Met', value: 'no' }
    ]
  },
  {
    key: 'email',
    label: 'Email Address',
    defaultValue: '',
    type: 'email',
    size: 6,
    required: false,
    placeholder: 'Enter Email Address',
    rules: {
      required: {
        value: false,
        message: 'Email is Required'
      },
      pattern: {
        value: /^([a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+(?:\<?)+([a-zA-Z0-9-]?)+(?:\.?)+([a-zA-Z0-9-]?)+(?:\.?)+([a-zA-Z0-9-]?)+(?:\.?)+([a-zA-Z0-9-]?)+@[a-zA-Z0-9-]+(?:\.?)+([a-zA-Z0-9-]?)+(?:\.[a-zA-Z0-9-]+(?:\>?)+(?:\;?)+))*$/,
        message: 'Invalid email address'
      }
    }
  },
  {
    key: 'notificationMessage',
    label: 'Notification Message',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: true,
    placeholder: 'Enter Message',
    rules: {
      required: {
        value: true,
        message: 'Message is Required'
      }
    }
  },
  {
    key: 'searchPeriod',
    label: 'Search Period(min)',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: true,
    placeholder: 'Enter search Period',
    rules: {
      required: {
        value: true,
        message: 'Expression is Required(mins)'
      }
    }
  },
  {
    key: 'filterRule',
    label: 'Filter Rule',
    defaultValue: '',
    type: 'text',
    size: 12,
    required: true,
    disabled: true,
    placeholder: '',
    rules: {
      required: {
        value: true,
        message: ''
      }
    }
  }
];

export default AddNotificationFormDataConfig;
